module.exports = __webpack_public_path__ + "static/img/img7.b4343d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img7.png
// module id = 2BVt
// module chunks = 0